<div class="relative h-full w-full">
  <!-- 遮罩（scss 类，含淡入动画） -->
  <div class="backdrop" (click)="closeDrawer()"></div>

  <!-- 抽屉宽度随「左栏 328 + 右栏 800」收缩，避免右侧留出空白；窄屏由右栏收缩兜底 -->
  <div class="flex relative gap-[8px] w-fit max-w-full overflow-hidden bg-neutral-n9 h-full p-2">
    <!-- 左栏：消息列表 -->
    <div class="w-[328px] rounded-lg shrink-0 h-full flex flex-col bg-white">
      <div class="p-[16px] text-base font-medium flex items-center justify-between">
        <span>消息</span>
        <div class="flex items-center gap-[8px]">
          <!-- 筛选「未读」时后端只返回有未读消息的任务 -->
          <nz-segmented
            nzSize="small"
            [(ngModel)]="threadFilter"
            (ngModelChange)="onThreadFilterChange($event)"
          >
            <label nz-segmented-item [nzValue]="MessageThreadFilter.All">全部</label>
            <label nz-segmented-item [nzValue]="MessageThreadFilter.Unread">未读</label>
          </nz-segmented>
          <nz-badge [nzDot]="hasNewMessage">
            <button nz-button nzType="text" nz-tooltip nzTooltipTitle="刷新" nzSize="small" (click)="refreshThreads()" class="ant-btn-icon-only">
              <lib-fl-icon name="icon-shuaxin" ></lib-fl-icon>
            </button>
          </nz-badge>
        </div>
      </div>

      <div #threadScroll class="flex-1 min-h-0 overflow-y-auto space-y-[8px] p-2 pt-0" (scroll)="onThreadScroll($event)">
        @for (thread of threads; track thread.taskId) {
          @if (thread.type === 0) {
            <!-- 系统消息入口：无手风琴，点击进右栏通知列表 -->
            <fl-system-message-item
              [thread]="thread"
              [active]="isSystemActive"
              [unreadCount]="systemUnread"
              (toggle)="toggleTaskThread(thread)"
            ></fl-system-message-item>
          } @else {
            <fl-task-message-item
              [thread]="thread"
              [expanded]="expandedTaskId === thread.taskId"
              [first]="$index === 0"
              [selectedThreadId]="activeTaskId === thread.taskId ? activeThreadId : null"
              [uncleared]="expandedTaskId === thread.taskId ? unclearedEvent : null"
              [refreshTick]="refreshTick"
              (toggle)="toggleTaskThread(thread)"
              (selectQuestion)="onSelectTaskQuestion(thread, $event)"
              (defaultQuestion)="onTaskDefaultQuestion(thread.taskId, $event)"
            ></fl-task-message-item>
          }
        } @empty {
          <div class="p-[40px] text-center text-neutral-n4">暂无消息</div>
        }
        @if (threadsLoading) {
          <div class="shrink-0 py-[12px] flex justify-center">
            <nz-spin nzSize="small"></nz-spin>
          </div>
        }
        <!-- 空列表时 @empty 已提示「暂无消息」，仅在列表有内容时才显示到底提示，避免两个提示同时出现 -->
        @if (threads.length > 0 && threadReachedBottom && !threadsLoading) {
          <div class="shrink-0 py-[16px] text-center text-[12px] text-neutral-n4">没有更多了</div>
        }
      </div>
    </div>

    <!-- 右栏：会话详情区，固定 800 宽；窄屏下允许收缩避免溢出 -->
    <div class="w-[800px] shrink min-w-0 rounded-lg h-full flex flex-col bg-white overflow-hidden">
      @if (isSystemActive) {
        <div class="flex-1 min-h-0">
          <fl-notice-list></fl-notice-list>
        </div>
      } @else if (activeTaskId; as taskId) {
        <div class="flex-1 min-h-0">
          <fl-task-message-list
            [taskId]="taskId"
            [externalThreadId]="activeThreadId ?? undefined"
            (unreadCleared)="onTaskUnreadCleared($event)"
          ></fl-task-message-list>
        </div>
      } @else {
        <div class="flex-1 flex flex-col items-center justify-center">
          <img src="https://s-chengdu.100tifen.com/module/cloud/imgs/teacher-tips.webp" alt="" class=" h-[120px]" />
          <div class="mt-[24px] text-[14px] text-neutral-n2">选择任务，回复学生消息</div>
        </div>
      }
    </div>
  </div>
</div>
